/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react";
import rightCar from "../../assets/right-car.png";
import leftCar from "../../assets/left-car.png";
import internalCar from "../../assets/internal-car.png";
import upCar from "../../assets/up-car.png";
import backCar from "../../assets/back-car.png";
import frontCar from "../../assets/front-car.png";
import SliderComponent from "../Slider";
import AudioRecorder from "../AudioRecorder";
import API from "../../utils/API";
import Swal from "sweetalert2";
import axios from "axios";
import { useSearchParams, useNavigate } from 'react-router-dom';

const SERVICE_CATEGORIES = [
    { code: 'MEC', label: 'Mecânica', icon: '🔧' },
    { code: 'ELE', label: 'Elétrica', icon: '⚡' },
    { code: 'FUN', label: 'Funilaria', icon: '🔨' },
    { code: 'PIN', label: 'Pintura', icon: '🎨' },
    { code: 'TAP', label: 'Tapeçaria', icon: '🪑' },
    { code: 'LAV', label: 'Lavagem', icon: '💧' },
    { code: 'POL', label: 'Polimento', icon: '✨' },
    { code: 'MAR', label: 'Martelinho', icon: '🔩' },
    { code: 'VIT', label: 'Vitrificação', icon: '💎' },
    { code: 'TER', label: 'Terceiros', icon: '🤝' },
    { code: 'OUT', label: 'Outros', icon: '📋' },
    { code: 'ACA', label: 'Acabamento', icon: '🖌️' },
    { code: 'ALM', label: 'Almoxarifado', icon: '📦' },
];

const CAR_VIEWS = [
    { key: "Direita", label: "Direita", img: rightCar },
    { key: "Esquerda", label: "Esquerda", img: leftCar },
    { key: "Dianteira", label: "Dianteira", img: frontCar },
    { key: "Traseira", label: "Traseira", img: backCar },
    { key: "Topo", label: "Topo", img: upCar },
    { key: "Interno", label: "Interno", img: internalCar },
];

export default function InputChecklist(props) {
    const [selectedDetail, setSelectedDetail] = useState("Direita");
    const [selectedImage, setSelectedImage] = useState(rightCar);
    const [imageFiles, setImageFiles] = useState([]);
    const [removingAudio, setRemovingAudio] = useState([]);
    const navigate = useNavigate();

    let userRole = "";
    try { userRole = JSON.parse(localStorage.getItem("yc_usr_dt_ls"))?.role || ""; } catch (e) { userRole = ""; }
    const advanceLabel =
        userRole === "RECEPCAO" ? "Liberar para Oficina"
        : userRole === "MECANICO" ? "Ir para o Checklist Obrigatório"
        : "Avançar";

    const [selectedCategories, setSelectedCategories] = useState([]);
    const toggleCategory = (code) => {
        setSelectedCategories(prev => prev.includes(code) ? prev.filter(c => c !== code) : [...prev, code]);
    };

    const [basicInfo, setBasicInfo] = useState({
        user: localStorage.getItem('client_id'), vehicle: localStorage.getItem('vehicle_id'),
        problem_description: '', audio_url: '', audio_urls: [], kms: '', fuel: '',
        comments: [], images: [], audios: [], service_categories: [],
    });

    const [comments, setComments] = useState({
        Direita: [], Esquerda: [], Topo: [], Traseira: [], Dianteira: [], Interno: []
    });

    const [clickPosition, setClickPosition] = useState(null);
    const [sliderValue, setSliderValue] = useState(50);
    const [newComment, setNewComment] = useState({ title: '', description: '' });
    const [selectedCommentIndex, setSelectedCommentIndex] = useState(null);
    const [audioUrls, setAudioUrls] = useState([]);

    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');

    // ---- Data loading ----
    useEffect(() => {
        if (id) {
            Swal.fire({ title: 'Carregando dados', showConfirmButton: false, allowOutsideClick: false, didOpen: () => Swal.showLoading() });
            API.getChecklistService(API.cancelToken(), id).then(res => {
                const fetchedAudioUrls = Array.isArray(res.data.audio_urls) ? res.data.audio_urls : (res.data.audio_url ? [res.data.audio_url] : []);
                setBasicInfo(prev => ({
                    ...prev, service_id: id, user: res.data.user, vehicle: res.data.vehicle,
                    problem_description: res.data.problem_description,
                    audio_url: fetchedAudioUrls[0] || '', audio_urls: fetchedAudioUrls,
                    kms: res.data.kms, fuel: parseInt(res.data.fuel),
                    comments: { Direita: res.data.comments?.Direita || [], Esquerda: res.data.comments?.Esquerda || [], Topo: res.data.comments?.Topo || [], Traseira: res.data.comments?.Traseira || [], Dianteira: res.data.comments?.Dianteira || [], Interno: res.data.comments?.Interno || [] },
                    images: res.data.images || [], audios: res.data.audios || []
                }));
                setAudioUrls(fetchedAudioUrls);
                if (Array.isArray(res.data.service_categories)) setSelectedCategories(res.data.service_categories);
                setImageFiles(res.data.images || []);
                if (res.data.fuel) setSliderValue(parseInt(res.data.fuel));
                if (res.data.comments) setComments({ Direita: res.data.comments.Direita || [], Esquerda: res.data.comments.Esquerda || [], Topo: res.data.comments.Topo || [], Traseira: res.data.comments.Traseira || [], Dianteira: res.data.comments.Dianteira || [], Interno: res.data.comments.Interno || [] });
                Swal.close();
            }).catch(err => { console.error(err); Swal.close(); });
        }
    }, [id]);

    // ---- Sync effects ----
    useEffect(() => { setBasicInfo(prev => ({ ...prev, images: imageFiles })); }, [imageFiles]);
    useEffect(() => { setBasicInfo(prev => ({ ...prev, audio_urls: audioUrls, audio_url: audioUrls[0] || '' })); }, [audioUrls]);
    useEffect(() => { setBasicInfo(prev => ({ ...prev, service_categories: selectedCategories })); }, [selectedCategories]);
    useEffect(() => { setBasicInfo(prev => ({ ...prev, comments })); }, [comments]);

    useEffect(() => {
        setClickPosition(null); setSelectedCommentIndex(null);
        const view = CAR_VIEWS.find(v => v.key === selectedDetail);
        if (view) setSelectedImage(view.img);
    }, [selectedDetail]);

    // ---- Handlers ----
    const handleChange = (e) => { setBasicInfo(prev => ({ ...prev, [e.target.name]: e.target.value })); };
    const handleSliderChange = (value) => { setSliderValue(value); setBasicInfo(prev => ({ ...prev, fuel: value })); };

    const handleImageClick = (event) => {
        const rect = event.target.getBoundingClientRect();
        setClickPosition({ x: event.clientX - rect.left, y: event.clientY - rect.top });
    };

    const handleImageUpload = async (event) => {
        const files = Array.from(event.target.files || []);
        if (!files.length) return;
        const imageTypes = ["image/jpeg", "image/png", "image/jpg", "image/gif", "image/webp"];
        const videoTypes = ["video/mp4", "video/webm", "video/quicktime", "video/x-matroska"];
        const imageMaxSize = 10 * 1024 * 1024;   // 10MB
        const videoMaxSize = 50 * 1024 * 1024;   // 50MB

        Swal.fire({ title: `Enviando ${files.length} arquivo(s)...`, showConfirmButton: false, allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        try {
            const uploads = await Promise.allSettled(files.map(async (file) => {
                const isImage = imageTypes.includes(file.type);
                const isVideo = videoTypes.includes(file.type) || (file.type || "").startsWith("video/");
                if (!isImage && !isVideo) throw new Error(`${file.name}: tipo inválido`);

                if (isImage && file.size > imageMaxSize) throw new Error(`${file.name}: imagem > 10MB`);
                if (isVideo && file.size > videoMaxSize) throw new Error(`${file.name}: vídeo > 50MB`);

                const formData = new FormData(); formData.append("file", file);
                const resp = await axios.post("https://youconnected-f6114d7c794c.herokuapp.com/api/upload/image", formData, { headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${localStorage.getItem('token')}` } });
                return resp.data.file_url || resp.data.url;
            }));
            const successUrls = uploads.filter(r => r.status === "fulfilled" && r.value).map(r => r.value);
            const errors = uploads.filter(r => r.status === "rejected").map(r => r.reason?.message || "Falha no upload");
            if (successUrls.length) setImageFiles(prev => [...prev, ...successUrls]);
            if (errors.length) Swal.fire({ icon: 'warning', title: 'Alguns arquivos falharam', html: `<div style="text-align:left">${errors.join("<br/>")}</div>` });
            else Swal.close();
        } catch (e) { console.error(e); Swal.fire('Erro', 'Não foi possível enviar os arquivos.', 'error'); }
        finally { event.target.value = ""; if (Swal.isLoading()) Swal.close(); }
    };

    const handleAudioUpload = (url) => { if (url) setAudioUrls(prev => [...prev, url]); };
    const removeAudioAt = (idx) => {
        setRemovingAudio(prev => [...prev, idx]);
        API.removeAudio(API.cancelToken(), audioUrls[idx]).then(() => {
            setAudioUrls(prev => prev.filter((_, i) => i !== idx));
            setRemovingAudio(prev => prev.filter(i => i !== idx));
        }).catch(err => console.error("Failed to remove audio:", err));
    };

    const handleCommentClick = (comment, index) => { setClickPosition(comment.clickPosition); setSelectedCommentIndex(index); };
    const addComment = () => {
        const commentWithPos = { ...newComment, clickPosition };
        const updated = { ...comments, [selectedDetail]: [...comments[selectedDetail], commentWithPos] };
        setComments(updated);
        setNewComment({ title: '', description: '' });
    };

    const renderCircles = () => {
        const circles = [];
        (comments[selectedDetail] || []).forEach((comment, index) => {
            if (comment.clickPosition) {
                circles.push(<div key={`saved-${index}`} onClick={(e) => { e.stopPropagation(); handleCommentClick(comment, index); }}
                    style={{ position: 'absolute', top: `${comment.clickPosition.y}px`, left: `${comment.clickPosition.x}px`, width: '15px', height: '15px', backgroundColor: selectedCommentIndex === index ? '#ff0000' : '#cc0000', borderRadius: '50%', transform: 'translate(-50%, -50%)', cursor: 'pointer', border: selectedCommentIndex === index ? '2px solid #fff' : 'none', zIndex: selectedCommentIndex === index ? 10 : 1 }} />);
            }
        });
        if (clickPosition && selectedCommentIndex === null) {
            circles.push(<div key="new" style={{ position: 'absolute', top: `${clickPosition.y}px`, left: `${clickPosition.x}px`, width: '15px', height: '15px', backgroundColor: 'red', borderRadius: '50%', transform: 'translate(-50%, -50%)', zIndex: 10 }} />);
        }
        return circles;
    };

    const moveOn = () => {
        const problemOk = String(basicInfo.problem_description ?? "").trim() !== "";
        const kmsOk = String(basicInfo.kms ?? "").trim() !== "";
        if (!problemOk || !kmsOk) {
            Swal.fire({ title: 'Campos obrigatórios', text: 'Preencha "Problema relatado" e "KM Rodados" antes de prosseguir.', icon: 'warning', confirmButtonText: 'Ok' });
            return;
        }
        Swal.fire({ title: 'Salvando informações...', showConfirmButton: false, allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        localStorage.setItem('serviceInfo', JSON.stringify(basicInfo));
        API.postService(API.cancelToken(), basicInfo).then(res => {
            localStorage.setItem('service_id', res.data.service_id);
            Swal.close();

            if (userRole === 'MECANICO') {
                // O mecânico entra por esta tela só para conferir o que a
                // recepção apurou (queixa do cliente, fotos, áudios) antes de
                // preencher o checklist obrigatório. Para ele, avançar é ir
                // para o passo 4 — não é o fim de um processo.
                props.nextStep(4);
                navigate('/create/service?step=4&id=' + id);
                return;
            }

            // Encerrada a etapa da recepção, o usuário volta para a home.
            // Antes ele caía na tela do mecânico (step 4), o que dava a
            // impressão de que o processo não tinha sido concluído.
            Swal.fire({
                title: 'Check-in concluído!',
                text: 'A OS foi enviada para o mecânico realizar a análise.',
                icon: 'success',
                confirmButtonText: 'Ok'
            }).then(() => navigate('/dashboard'));
        }).catch(() => {
            Swal.fire({ title: 'Erro ao salvar', text: 'Tente novamente mais tarde.', icon: 'error', confirmButtonText: 'Ok' });
        });
    };

    const totalComments = Object.values(comments).reduce((sum, arr) => sum + arr.length, 0);

    return (
        <div className="flex flex-col items-center w-full bg-white rounded-lg shadow-sm">
            {/* Header */}
            <div className="w-full px-8 pt-6 pb-4 border-b border-gray-100 max-md:px-5">
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-lg bg-[#389E0D] bg-opacity-10 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-[#389E0D]" viewBox="0 0 20 20" fill="currentColor">
                            <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                            <path fillRule="evenodd" d="M4 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v11a2 2 0 01-2 2H6a2 2 0 01-2-2V5zm3 4a1 1 0 000 2h.01a1 1 0 100-2H7zm3 0a1 1 0 000 2h3a1 1 0 100-2h-3zm-3 4a1 1 0 100 2h.01a1 1 0 100-2H7zm3 0a1 1 0 100 2h3a1 1 0 100-2h-3z" clipRule="evenodd" />
                        </svg>
                    </div>
                    <div>
                        <h2 className="text-xl font-semibold text-gray-900">Checklist de Entrada</h2>
                        <p className="text-sm text-gray-500">Registre o estado do veículo e o problema relatado</p>
                    </div>
                </div>
            </div>

            <div className="w-full px-8 py-6 space-y-8 max-md:px-5">
                {/* Section: Problema relatado */}
                <div>
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Problema Relatado <span className="text-red-500">*</span>
                    </h3>
                    <textarea
                        className="w-full min-h-[150px] resize-y rounded-lg border-2 border-gray-200 px-4 py-3 text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent"
                        placeholder="Descreva o problema relatado pelo cliente..."
                        name="problem_description"
                        value={basicInfo.problem_description}
                        onChange={handleChange}
                    />
                </div>

                {/* Section: Tipo de Serviço */}
                <div>
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M17.707 9.293a1 1 0 010 1.414l-7 7a1 1 0 01-1.414 0l-7-7A.997.997 0 012 10V5a3 3 0 013-3h5c.256 0 .512.098.707.293l7 7zM5 6a1 1 0 100-2 1 1 0 000 2z" clipRule="evenodd" />
                        </svg>
                        Tipo de Serviço
                    </h3>
                    <div className="flex flex-wrap gap-2">
                        {SERVICE_CATEGORIES.map(cat => {
                            const isActive = selectedCategories.includes(cat.code);
                            return (
                                <button key={cat.code} type="button" onClick={() => toggleCategory(cat.code)}
                                    className={`flex items-center gap-1.5 px-3 py-2 rounded-lg border-2 text-sm font-medium transition-all ${isActive ? "border-[#389E0D] bg-green-50 text-[#389E0D]" : "border-gray-200 bg-white text-gray-600 hover:border-gray-300 hover:bg-gray-50"}`}>
                                    <span>{cat.icon}</span>
                                    <span className="font-bold">{cat.code}</span>
                                    <span className="hidden sm:inline text-xs opacity-75">- {cat.label}</span>
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Section: Audio & Images side by side */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Audio */}
                    <div className="border-2 border-gray-100 rounded-lg p-5">
                        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M7 4a3 3 0 016 0v4a3 3 0 11-6 0V4zm4 10.93A7.001 7.001 0 0017 8a1 1 0 10-2 0A5 5 0 015 8a1 1 0 00-2 0 7.001 7.001 0 006 6.93V17H6a1 1 0 100 2h8a1 1 0 100-2h-3v-2.07z" clipRule="evenodd" />
                            </svg>
                            Relatos em Áudio
                        </h3>
                        <AudioRecorder onUpload={handleAudioUpload}
                            uploadEndpoint="https://youconnected-f6114d7c794c.herokuapp.com/api/upload/audio"
                            uploadHeaders={{ Authorization: `Bearer ${localStorage.getItem('token')}` }} />
                        {audioUrls?.length > 0 && (
                            <div className="mt-4 flex flex-col gap-2">
                                {audioUrls.map((url, idx) => (
                                    <div key={`${url}-${idx}`} className="flex items-center justify-between bg-gray-50 rounded-lg p-3 border border-gray-200">
                                        <div className="flex items-center gap-3 flex-1 min-w-0">
                                            <span className="text-xs font-semibold text-gray-400 shrink-0">#{idx + 1}</span>
                                            <audio className="w-full min-w-0" controls src={url}></audio>
                                        </div>
                                        {removingAudio.includes(idx)
                                            ? <span className="ml-3 text-xs text-gray-400 italic shrink-0">Removendo...</span>
                                            : <button type="button" className="ml-3 shrink-0 p-1.5 text-red-500 hover:bg-red-50 rounded-lg transition-colors" onClick={() => removeAudioAt(idx)}>
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                                    <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z" clipRule="evenodd" />
                                                </svg>
                                            </button>
                                        }
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Images */}
                    <div className="border-2 border-gray-100 rounded-lg p-5">
                        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-4 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M4 3a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V5a2 2 0 00-2-2H4zm12 12H4l4-8 3 6 2-4 3 6z" clipRule="evenodd" />
                            </svg>
                            Imagens
                            {imageFiles.length > 0 && <span className="text-xs font-normal text-gray-400">({imageFiles.length})</span>}
                        </h3>
                        <div className="flex flex-wrap gap-2 items-center">
                            {imageFiles.map((url, index) => {
                                const ext = String(url).split('?')[0].split('.').pop().toLowerCase();
                                const isVideo = ["mp4", "webm", "mov", "m4v", "mkv"].includes(ext);
                                return (
                                    <div key={index} className="relative group">
                                        {isVideo ? (
                                            <video
                                                src={url}
                                                controls
                                                className="h-20 w-20 object-cover rounded-lg border-2 border-gray-200 bg-black"
                                            />
                                        ) : (
                                            <img src={url} alt="Foto" className="h-20 w-20 object-cover rounded-lg border-2 border-gray-200" />
                                        )}
                                    </div>
                                );
                            })}
                            <label className="flex items-center justify-center h-20 w-20 rounded-lg border-2 border-dashed border-gray-300 hover:border-[#389E0D] hover:bg-green-50 cursor-pointer transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                </svg>
                                <input type="file" accept="image/*,video/*" multiple onChange={handleImageUpload} className="hidden" />
                            </label>
                        </div>
                        <p className="text-xs text-gray-500 mt-2">
                            Imagens até 10MB. Vídeos até 50MB.
                        </p>
                    </div>
                </div>

                {/* Section: KM & Fuel */}
                <div>
                    <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-3 flex items-center gap-2">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        Informações Adicionais
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1.5">KM Rodados <span className="text-red-500">*</span></label>
                            <input
                                className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg text-sm transition-all focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent"
                                placeholder="Ex: 45000"
                                name="kms"
                                value={basicInfo.kms}
                                onChange={handleChange}
                                type="number"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-600 mb-1.5">Combustível</label>
                            <div className="pt-2">
                                <SliderComponent onChange={handleSliderChange} name="fuel" value={basicInfo.fuel} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section: Vistoria do carro */}
                <div className="border-2 border-gray-100 rounded-lg overflow-hidden">
                    <div className="px-5 py-4 bg-gray-50 border-b border-gray-100 flex items-center justify-between">
                        <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wider flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                <path d="M10 12a2 2 0 100-4 2 2 0 000 4z" />
                                <path fillRule="evenodd" d="M.458 10C1.732 5.943 5.522 3 10 3s8.268 2.943 9.542 7c-1.274 4.057-5.064 7-9.542 7S1.732 14.057.458 10zM14 10a4 4 0 11-8 0 4 4 0 018 0z" clipRule="evenodd" />
                            </svg>
                            Vistoria do Carro
                        </h3>
                        {totalComments > 0 && (
                            <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-700">
                                {totalComments} apontamento{totalComments !== 1 ? 's' : ''}
                            </span>
                        )}
                    </div>

                    {/* Tabs */}
                    <div className="flex border-b border-gray-200 overflow-x-auto">
                        {CAR_VIEWS.map(view => {
                            const isActive = selectedDetail === view.key;
                            const count = (comments[view.key] || []).length;
                            return (
                                <button key={view.key} type="button" onClick={() => setSelectedDetail(view.key)}
                                    className={`flex items-center gap-2 px-4 py-3 text-sm font-medium whitespace-nowrap border-b-2 transition-all ${isActive ? "border-[#389E0D] text-[#389E0D] bg-green-50" : "border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50"}`}>
                                    {view.label}
                                    {count > 0 && (
                                        <span className={`inline-flex items-center justify-center h-5 min-w-[20px] rounded-full text-xs font-bold ${isActive ? "bg-[#389E0D] text-white" : "bg-gray-200 text-gray-600"}`}>
                                            {count}
                                        </span>
                                    )}
                                </button>
                            );
                        })}
                    </div>

                    {/* Car image + comments */}
                    <div className="p-5">
                        <div className="flex flex-col items-center">
                            <div className="relative mb-6" style={{ width: 'fit-content' }}>
                                <img src={selectedImage} onClick={handleImageClick} className="cursor-crosshair max-h-[300px]" alt="Vistoria" />
                                {renderCircles()}
                            </div>

                            <div className="w-full max-w-lg space-y-3">
                                <div className="flex gap-2">
                                    <select value={newComment.description} onChange={e => setNewComment({ ...newComment, description: e.target.value })}
                                        className="flex-1 px-3 py-2.5 border-2 border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent">
                                        <option value="">Selecione o tipo...</option>
                                        <option value="TRINCADO">Trincado</option>
                                        <option value="AMASSADO">Amassado</option>
                                        <option value="RISCADO">Riscado</option>
                                        <option value="RALADO">Ralado</option>
                                        <option value="FALTANDO">Faltando</option>
                                        <option value="CAINDO">Caindo</option>
                                        <option value="OUTROS">Outros</option>
                                    </select>
                                    <button type="button" onClick={addComment}
                                        className="inline-flex items-center gap-1.5 px-4 py-2.5 bg-[#389E0D] text-white text-sm font-medium rounded-lg hover:bg-green-700 transition-colors shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                                            <path fillRule="evenodd" d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z" clipRule="evenodd" />
                                        </svg>
                                        Adicionar
                                    </button>
                                </div>

                                {newComment.description === "OUTROS" && (
                                    <input type="text" placeholder="Descreva a condição (ex: arranhado, amassado...)"
                                        value={newComment.title} onChange={e => setNewComment({ ...newComment, title: e.target.value })}
                                        className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#389E0D] focus:border-transparent" />
                                )}

                                {/* Comment list */}
                                {comments[selectedDetail].length > 0 && (
                                    <div className="space-y-2 pt-2">
                                        {comments[selectedDetail].map((comment, index) => (
                                            <div key={index} onClick={() => handleCommentClick(comment, index)}
                                                className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition-all ${selectedCommentIndex === index ? 'border-2 border-[#389E0D] bg-green-50' : 'border-2 border-gray-100 hover:border-gray-200'}`}>
                                                <div className="h-3 w-3 rounded-full bg-red-500 shrink-0"></div>
                                                <div>
                                                    <p className="text-sm font-medium text-gray-900">{comment.description}</p>
                                                    {comment.title && <p className="text-xs text-gray-500">{comment.title}</p>}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <div className="w-full px-8 py-5 border-t border-gray-100 flex justify-between max-md:px-5">
                <button onClick={() => navigate('/create/service?step=2&id=' + id)}
                    className="inline-flex items-center gap-2 px-5 py-2.5 border-2 border-gray-200 text-gray-600 font-medium text-sm rounded-lg hover:bg-gray-50 transition-colors">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                    </svg>
                    Voltar
                </button>
                <button onClick={moveOn}
                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-[#389E0D] text-white font-medium text-sm rounded-lg hover:bg-green-700 transition-colors shadow-sm">
                    {advanceLabel}
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                </button>
            </div>
        </div>
    );
}
